import { Injectable } from '@angular/core';
import { GoogleGenAI, Chat } from '@google/genai';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class GeminiService {
  private ai: GoogleGenAI | null = null;
  private chatSession: Chat | null = null;

  private getApiKey(): string {
    return (environment as { geminiApiKey?: string }).geminiApiKey?.trim() ?? '';
  }

  private getOrCreateClient(): GoogleGenAI {
    if (this.ai) return this.ai;
    const apiKey = this.getApiKey();
    if (!apiKey) {
      throw new Error('API key must be set when using the Gemini API. Configure geminiApiKey in your environment.');
    }
    this.ai = new GoogleGenAI({ apiKey });
    return this.ai;
  }

  private getSession(): Chat {
    if (!this.chatSession) {
      const client = this.getOrCreateClient();
      this.chatSession = client.chats.create({
        model: 'gemini-2.5-flash',
        config: {
          systemInstruction:
            'You are a helpful, witty, and concise AI assistant integrated into a web application. You help users navigate the app and answer general questions.',
        },
      });
    }
    return this.chatSession;
  }

  isConfigured(): boolean {
    return this.getApiKey().length > 0;
  }

  async sendMessage(message: string): Promise<AsyncIterable<{ text: string }>> {
    const session = this.getSession();
    const result = await session.sendMessageStream({ message });
    return result as AsyncIterable<{ text: string }>;
  }
}
